import { SVGIconComponent } from './types';

export const AccessLocked: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/access-locked" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="np_unlock_311917_000000" transform="translate(4, 1)" fill="currentColor" fillRule="nonzero">
        <path
          d="M14.787838,22 L1.21216203,22 C0.538738678,22 0,21.4507516 0,20.7641911 L0,8.04881592 C0,7.36225541 0.538738678,6.81300701 1.21216203,6.81300701 L14.787838,6.81300701 C15.4612613,6.81300701 16,7.36225541 16,8.04881592 L16,20.7361794 C16,21.4506417 15.4612613,22 14.787838,22 L14.787838,22 Z M2.42432405,19.5283822 L13.5756759,19.5283822 L13.5756759,9.28462483 L2.42432405,9.28462483 L2.42432405,19.5283822 Z"
          id="Shape"
        ></path>
        <path
          d="M4.9558571,8.67088943 L2.53153305,8.67088943 L2.53153305,5.68787165 C2.53153305,2.66700543 4.82117243,0.112725728 7.78423516,0.00342529554 C10.8819826,-0.105995971 13.4409913,2.42033797 13.4409913,5.55055955 L13.4409913,6.64905636 C13.4409913,6.95158238 13.1989791,7.19830476 12.9022526,7.19830476 L11.5554059,7.19830476 C11.2586686,7.19830476 11.0166672,6.95157139 11.0166672,6.64905636 L11.0166672,5.65996983 C11.0166672,4.04012644 9.85816357,2.63910361 8.26936934,2.50179151 C6.46481026,2.33658858 4.9558571,3.76550224 4.9558571,5.57730795 L4.9558571,8.67088943 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </svg>
);
